// AUTO-GENERATED by scripts/scrape-events.mjs from evwsports.com (official results) — do not hand-edit.
// Full East vs West archive: every event's card with winner, score, loser, arm and weight class.

export interface EventResult { winner: string; loser: string; score: string; arm: 'left' | 'right'; weightClass: string }
export interface EvwEventRecord {
  num: number;
  slug: string;
  name: string;
  city: string;
  country: string;
  isoDate: string;
  matches: EventResult[];
}

export const EVENT_ARCHIVE: EvwEventRecord[] = [
  {
    "num": 27,
    "slug": "evw-27",
    "name": "East vs West 27",
    "city": "Budapest",
    "country": "Hungary",
    "isoDate": "2026-10-24",
    "matches": [
      {
        "winner": "Peter Čeleš",
        "loser": "Omer Dror",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Andrei Lupsa",
        "loser": "Erik Fahlgren",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Petros Peridis",
        "loser": "Tom Holland",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Malin Bergström",
        "loser": "Brigitta Ivánfi",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Eldar Bubenko",
        "loser": "Zurab Tavberidze",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Gabor Botta Dukat",
        "loser": "Daniyar Roman",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Janis Amolins",
        "loser": "Davit Samushia",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Serhii Kalinichenko",
        "loser": "Matt Mask",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Oleksandr Telyatnik",
        "loser": "Todd Hutchings",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Georgi Tsvetkov",
        "loser": "Alex Kurdecha",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Oleg Petrenko",
        "loser": "Dave Chaffee",
        "score": "4-3",
        "arm": "right",
        "weightClass": "Heavyweight Interim World Title"
      },
      {
        "winner": "Ibragim Sagov",
        "loser": "Devon Larratt",
        "score": "4-3",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Kamil Jablonski",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 26,
    "slug": "evw-26",
    "name": "East vs West 26",
    "city": "Jiaxing",
    "country": "China",
    "isoDate": "2026-09-12",
    "matches": [
      {
        "winner": "Lao Wu",
        "loser": "Dai Zheng",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Zhuo Xiaohai",
        "loser": "Joffey Jolly",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Raimonds Liepiņš",
        "loser": "Rui Jiale",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Ethan Lovei",
        "loser": "Josh Nicholas",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Featherweight"
      },
      {
        "winner": "Kersten Mercieca",
        "loser": "Tanapat Thammaya",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Joseph Meranto",
        "loser": "Valen Low",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Featherweight"
      },
      {
        "winner": "Fia Reisek",
        "loser": "Yrysty Orazkhan",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Rustam Babaiev",
        "loser": "Eldar Bubenko",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Barbora Bajčiová",
        "loser": "Marta Volkova",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Open Weight World Title"
      },
      {
        "winner": "Oleg Chersakov",
        "loser": "Arthur Makarov",
        "score": "4-3",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Riekerd Bornman",
        "loser": "Filip Larsson",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Zhao Zi Rui",
        "loser": "John Brzenk",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Bogdan Stoica",
        "loser": "Irakli Zirakashvili",
        "score": "4-3",
        "arm": "right",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Matt Mask",
        "loser": "Leonidas Arkona",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Ivan Matyushenko",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Heavyweight"
      }
    ]
  },
  {
    "num": 25,
    "slug": "evw-25",
    "name": "East vs West 25",
    "city": "Batumi",
    "country": "Georgia",
    "isoDate": "2026-08-01",
    "matches": [
      {
        "winner": "Vlad Krasovskis",
        "loser": "Artem Popov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Tim Tallmadge",
        "loser": "Vala Ichqiti",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Zurab Tavberidze",
        "loser": "Ryan Belanger",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Gabriela Vasconcelos",
        "loser": "Irina Driaeva",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Open Weight"
      },
      {
        "winner": "Adam Wawrzynski",
        "loser": "Nurdaulet Aidarkhan",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Eldar Bubenko",
        "loser": "Paul Linn",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Daniel Procopciuc",
        "loser": "Vachagan Hovhannisyan",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Krasimir Kostadinov",
        "loser": "Nugzari Chikadze",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Ibragim Sagov",
        "loser": "Yordan Tsonev",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Oleh Zhokh",
        "loser": "Luka Tsinadze",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Kamil Jablonski",
        "loser": "Georgi Tsvetkov",
        "score": "4-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Alizhan Muratov",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 24,
    "slug": "evw-24",
    "name": "East vs West 24",
    "city": "Little Rock",
    "country": "USA",
    "isoDate": "2026-06-06",
    "matches": [
      {
        "winner": "Bob Brown",
        "loser": "Isaiah Jones",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Courtney Huycke",
        "loser": "Nastasia Pastorkova",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Ryan Belanger",
        "loser": "Jason Merlo",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Jeremy Parker",
        "loser": "Auden Larratt",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Irakli Zirakashvili",
        "loser": "Yoshinobu Kanai",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Adam Wawrzynski",
        "loser": "Peter Čeleš",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Tom Holland",
        "loser": "Justin Bishop",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Janis Amolins",
        "loser": "Craig Tullier",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Corey West",
        "loser": "Pavlo Derbedyenyev",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Jerry Cadorette",
        "loser": "Kody Merritt",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Tobias Sporrong",
        "loser": "Alex Kurdecha",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Riekerd Bornman",
        "loser": "Alizhan Muratov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Bogdan Stoica",
        "loser": "Todd Hutchings",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Ermes Gasparini",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      }
    ]
  },
  {
    "num": 23,
    "slug": "evw-23",
    "name": "East vs West 23",
    "city": "Wuppertal",
    "country": "Germany",
    "isoDate": "2026-04-18",
    "matches": [
      {
        "winner": "Duvan Bornman",
        "loser": "André Nykonenko",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Aleksi Zavrashvili",
        "loser": "Artem Oriabinskyi",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Zurab Tavberidze",
        "loser": "Maayan Shterengas",
        "score": "3-2",
        "arm": "left",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Riekerd Bornman",
        "loser": "Lars Rørbakken",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Egle Vaitkute",
        "loser": "Azra Sari",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Openweight"
      },
      {
        "winner": "Betkili Oniani",
        "loser": "Rustam Babaiev",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Middleweight #1 Contender"
      },
      {
        "winner": "Aymeric Pradines",
        "loser": "Matt Mask",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Ayane Takenaka",
        "loser": "Melek Sahin",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Featherweight World Title"
      },
      {
        "winner": "Alizhan Muratov",
        "loser": "Artyom Morozov",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Artur Makarov",
        "loser": "Mindaugas Tarasaitis",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Oleksandr Telyatnik",
        "loser": "Davit Samushia",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Ivan Matyushenko",
        "loser": "Dave Chaffee",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Heavyweight World Title"
      },
      {
        "winner": "Leonidas Arkona",
        "loser": "Brian Shaw",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Vitaly Laletin",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      }
    ]
  },
  {
    "num": 22,
    "slug": "evw-22",
    "name": "East vs West 22",
    "city": "Vienna",
    "country": "Austria",
    "isoDate": "2026-02-28",
    "matches": [
      {
        "winner": "Eldar Bubenko",
        "loser": "Logan Bittinger",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Esra Kiraz",
        "loser": "Carolina Pettersson",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Featherweight"
      },
      {
        "winner": "Luka Tsinadze",
        "loser": "Eli Saidov",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Peter Čeleš",
        "loser": "Curtis Cameron",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Nugzari Chikadze",
        "loser": "Bogdan Stoica",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Oleksandr Telyatnik",
        "loser": "Vladislav Krasovskis",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight #1 Contender"
      },
      {
        "winner": "Efe Kömek",
        "loser": "Tarkhan Muzaffarov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Matt Mask",
        "loser": "Davit Arabuli",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Fia Reisek",
        "loser": "Brigitta Ivánfi",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Yordan Tsonev",
        "loser": "Serhii Kalinichenko",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Oleg Petrenko",
        "loser": "Todd Hutchings",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Light Heavyweight World Title"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Devon Larratt",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 21,
    "slug": "evw-21",
    "name": "East vs West 21",
    "city": "Atlantic City",
    "country": "USA",
    "isoDate": "2025-12-13",
    "matches": [
      {
        "winner": "Curtis Cameron",
        "loser": "Duvan Bornman",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Jocelyne Brisson",
        "loser": "Anna Grönlund",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Open Weight"
      },
      {
        "winner": "Maayan Shterengas",
        "loser": "Jason Merlo",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Aleksandr Beziazykov",
        "loser": "Riekerd Bornman",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Ayane Takenaka",
        "loser": "Victoria Karlsson",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Bogdan Stoica",
        "loser": "Paul Linn",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Tobias Sporrong",
        "loser": "Georgii Dzeranov",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Yordan Tsonev",
        "loser": "Evgeny Prudnik",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Daniel Procopciuc",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Riekerd Bornman",
        "loser": "Aleksandr Beziazykov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Kamil Jablonski",
        "loser": "Jerry Cadorette",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      }
    ]
  },
  {
    "num": 20,
    "slug": "evw-20",
    "name": "East vs West 20",
    "city": "Zürich",
    "country": "Switzerland",
    "isoDate": "2025-11-01",
    "matches": [
      {
        "winner": "Snizhana Babaieva",
        "loser": "Elina Persson",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Featherweight"
      },
      {
        "winner": "Efe Kömek",
        "loser": "Manuel Battaglia",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Matt Mask",
        "loser": "Serhii Kalinichenko",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Danil Ustinov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Yoshinobu Kanai",
        "loser": "Petro Marharint",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Oleg Zhokh",
        "loser": "Toms Rozits",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Barbora Bajčiová",
        "loser": "Gabriela Vasconcelos",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Open Weight World Title"
      },
      {
        "winner": "David Dadikyan",
        "loser": "Kamil Jablonski",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "Irakli Zirakashvili",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Oleg Petrenko",
        "loser": "Nugzari Chikadze",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Light Heavyweight World Title"
      },
      {
        "winner": "Dave Chaffee",
        "loser": "Ibragim Sagov",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Heavyweight World Title"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Jerry Cadorette",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      }
    ]
  },
  {
    "num": 19,
    "slug": "evw-19",
    "name": "East vs West 19",
    "city": "Loveland",
    "country": "USA",
    "isoDate": "2025-08-15",
    "matches": [
      {
        "winner": "Derek Smith",
        "loser": "Cire Brown",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Laurence Shahlaei",
        "loser": "Martins Licis",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Gabriela Vasconcelos",
        "loser": "Jocelyne Brisson",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Open Weight"
      },
      {
        "winner": "Riekerd Bornman",
        "loser": "Pavlo Derbedyenyev",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Filip Larsson",
        "loser": "Matt Mask",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Alex Kurdecha",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Eddie Hall",
        "loser": "Robert Oberst",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Dave Chaffee",
        "loser": "Todd Hutchings",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Alex Kurdecha",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      }
    ]
  },
  {
    "num": 18,
    "slug": "evw-18",
    "name": "East vs West 18",
    "city": "Chicago",
    "country": "USA",
    "isoDate": "2025-06-21",
    "matches": [
      {
        "winner": "Riekerd Bornman",
        "loser": "Wallace Dilley",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Ryan Belanger",
        "loser": "Allen Ford",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Joseph Meranto",
        "loser": "Ivan Portela",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Featherweight"
      },
      {
        "winner": "Pavlo Derbedyenyev",
        "loser": "Wagner Bortolato",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Alex Kurdecha",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Matt Mask",
        "loser": "Irakli Zirakashvili",
        "score": "3-2",
        "arm": "left",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Fia Reisek",
        "loser": "Elin Janeheim",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Alex Kurdecha",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Levan Saginashvili",
        "loser": "Ermes Gasparini",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 17,
    "slug": "evw-17",
    "name": "East vs West 17",
    "city": "Arlington",
    "country": "USA",
    "isoDate": "2025-03-29",
    "matches": [
      {
        "winner": "Arsen Khachatryan",
        "loser": "Andrei Sharkevich",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Joseph Meranto",
        "loser": "Cody Wood",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Hunter Noffz",
        "loser": "Valen Low",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Craig Tullier",
        "loser": "John Therrien",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Janis Amolins",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Evgeny Prudnik",
        "loser": "Kody Merritt",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Hunter Noffz",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Matt Mask",
        "loser": "Kydyrgali Ongarbaev",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Georgi Tsvetkov",
        "loser": "Dave Chaffee",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Corey West",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Yoshinobu Kanai",
        "loser": "John Brzenk",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      }
    ]
  },
  {
    "num": 16,
    "slug": "evw-16",
    "name": "East vs West 16",
    "city": "Tbilisi",
    "country": "Georgia",
    "isoDate": "2025-02-15",
    "matches": [
      {
        "winner": "Stoyan Golemanov",
        "loser": "Vasily Dautashvili",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Bacho Saginashvili",
        "loser": "Brad Grundy",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Serhii Kalinichenko",
        "loser": "Frank Lamparelli",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "David Dadikyan",
        "loser": "Alex Kurdecha",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Fia Reisek",
        "loser": "Malin Bergström",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Oleg Zhokh",
        "loser": "Daniel Procopciuc",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Oleg Petrenko",
        "loser": "Betkili Onianii",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "Irakli Zirakashvili",
        "score": "4-2",
        "arm": "right",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Genadi Kvikvinia",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Artyom Morozov",
        "score": "4-2",
        "arm": "left",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 15,
    "slug": "evw-15",
    "name": "East vs West 15",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2024-11-02",
    "matches": [
      {
        "winner": "Brigitta Ivánfi",
        "loser": "Irina Gladkaya",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Danil Ustinov",
        "loser": "Azat Srapyan",
        "score": "4-3",
        "arm": "right",
        "weightClass": "Featherweight World Title"
      },
      {
        "winner": "Nugzari Chikadze",
        "loser": "Oguzhan Koçak",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Artur Makarov",
        "loser": "Ömer Kozakoğlu",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Dimitrina Petrova",
        "loser": "Carolina Pettersson",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Betkili Oniani",
        "loser": "Oleg Zhokh",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "Yoshinobu Kanai",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Rino Mašić",
        "loser": "Ibragim Sagov",
        "score": "4-3",
        "arm": "right",
        "weightClass": "Heavyweight World Title"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Georgii Dzeranov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Irakli Zirakashvili",
        "loser": "Georgii Tautiev",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Vladimir Maiorov",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Alizhan Muratov",
        "loser": "Ivan Matyushenko",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Heavyweight World Title"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Oleg Petrenko",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Light Heavyweight World Title"
      }
    ]
  },
  {
    "num": 14,
    "slug": "evw-14",
    "name": "East vs West 14",
    "city": "Orlando",
    "country": "USA",
    "isoDate": "2024-08-10",
    "matches": [
      {
        "winner": "Ryan Belanger",
        "loser": "Raimonds Liepiņš",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Aymeric Pradines",
        "loser": "Jonathon Breda",
        "score": "3-2",
        "arm": "left",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Elizabeth Mocek",
        "loser": "Aleksandra Ozerova",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Hunter Noffz",
        "loser": "Doug Erlich",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Corey West",
        "loser": "Travis Bagent",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Vrezh Sedrakyan",
        "loser": "Paul Talbott",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Matt Mask",
        "loser": "Lars Rørbakken",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Janis Amolins",
        "loser": "Justin Bishop",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Dave Chaffee",
        "loser": "Frank Lampirelli",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Artem Taranenko",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Craig Tullier",
        "loser": "Tom Holland",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Chance Shaw",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Rustam Babaiev",
        "loser": "Paul Linn",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "Evgeny Prudnik",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "John Brzenk",
        "loser": "Leonidas Arkona",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Jerry Cadorette",
        "loser": "Alex Kurdecha",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      }
    ]
  },
  {
    "num": 13,
    "slug": "evw-13",
    "name": "East vs West 13",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2024-07-06",
    "matches": [
      {
        "winner": "Toms Rozits",
        "loser": "Artem Taranenko",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Carolina Pettersson",
        "loser": "Olga Terpelova",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Featherweight"
      },
      {
        "winner": "Petro Marharint",
        "loser": "Zurab Tavberidze",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Vladimir Maiorov",
        "loser": "Adam Wawrzynski",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Ibragim Sagov",
        "loser": "Chance Shaw",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Dimitrina Petrova",
        "loser": "Ayane Takenaka",
        "score": "4-2",
        "arm": "right",
        "weightClass": "Featherweight World Title"
      },
      {
        "winner": "Betkili Oniani",
        "loser": "Artem Taynov",
        "score": "4-1",
        "arm": "left",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Barbora Bajčiová",
        "loser": "Egle Vaitkute",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Openweight World Title"
      },
      {
        "winner": "Daniel Procopciuc",
        "loser": "Bozhidar Simeonov",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "Krasimir Kostadinov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Irakli Zirakashvili",
        "loser": "Evgeny Prudnik",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Serhii Kalinichenko",
        "loser": "Travis Bagent",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Oleg Petrenko",
        "loser": "David Dadikyan",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Light Heavyweight World Title"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Sasho Andreev",
        "score": "4-2",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Artyom Morozov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      }
    ]
  },
  {
    "num": 12,
    "slug": "evw-12",
    "name": "East vs West 12",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2024-04-20",
    "matches": [
      {
        "winner": "Stoyan Golemanov",
        "loser": "Brandon Ellsessor",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Betkili Oniani",
        "loser": "Talgat Aktaev",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Petro Marharint",
        "loser": "Nugzari Chikadze",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Ibragim Sagov",
        "loser": "Sandris Šedis",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Fia Reisik",
        "loser": "Ekaterina Nikisheva",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Artur Makarov",
        "loser": "Mindaugas Tarasaitis",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Kamil Jablonski",
        "loser": "Tobias Sporrong",
        "score": "3-2",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Leonidas Arkona",
        "loser": "Aleksandr Beziazykov",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Nurdaulet Aidarkhan",
        "score": "4-3",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Irakli Zirakashvili",
        "loser": "Sasho Andreev",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Alex Kurdecha",
        "loser": "Georgi Tsvetkov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Alizhan Muratov",
        "loser": "Ermes Gasparini",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Levan Saginashvili",
        "loser": "Devon Larratt",
        "score": "4-0",
        "arm": "right",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 11,
    "slug": "evw-11",
    "name": "East vs West 11",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2024-01-20",
    "matches": [
      {
        "winner": "Aymeric Pradines",
        "loser": "Robbie Topie",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Nurdalet Aidarkhan",
        "loser": "Vala Ichqiti",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Welter Weight"
      },
      {
        "winner": "Oleg Petrenko",
        "loser": "Marcio Barboza",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Oleg Zhokh",
        "loser": "Avtandil Tutberidze",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Daniel Procopciuc",
        "score": "4-2",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Artem Taynov",
        "loser": "Zurab Tavberidze",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Irakli Zirakashvili",
        "loser": "Paul Linn",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Matt Mask",
        "loser": "Wagner Bortolato",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Vladimir Maiorov",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Ivan Matyushenko",
        "loser": "Rino Mašić",
        "score": "4-1",
        "arm": "left",
        "weightClass": "Heavyweight World Title"
      },
      {
        "winner": "Krasimir Kostadinov",
        "loser": "John Brzenk",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Alizhan Muratov",
        "loser": "Evgeny Prudnik",
        "score": "4-0",
        "arm": "left",
        "weightClass": "Light Heavyweight World Title"
      },
      {
        "winner": "David Dadikyan",
        "loser": "Todd Hutchings",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Light Heavyweight World Title"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Alex Kurdecha",
        "score": "4-2",
        "arm": "left",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 10,
    "slug": "evw-10",
    "name": "East vs West 10",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2023-11-11",
    "matches": [
      {
        "winner": "Fia Reisek",
        "loser": "Rosa Acosta (Boltadano)",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Openweight"
      },
      {
        "winner": "Frank Lamparelli",
        "loser": "Matt Mask",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Artem Taynov",
        "loser": "Sasho Andreev",
        "score": "3-2",
        "arm": "left",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Ivan Matyushenko",
        "loser": "Kamil Jablonski",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Abdulmanaf Tuzuyev",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Irakli Zirakashvili",
        "loser": "Rustam Babaiev",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Egle Vaitkute",
        "loser": "Sarah Backman",
        "score": "5-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Georgi Tsvetkov",
        "loser": "Zaur Paizulaev",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "Kydyrgali Ongarbaev",
        "score": "5-0",
        "arm": "right",
        "weightClass": "Light Heavyweight World Title – Last two rounds aren’t pulled"
      },
      {
        "winner": "Sasho Andreev",
        "loser": "John Brzenk",
        "score": "5-0",
        "arm": "right",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Denis Cyplenkov",
        "score": "5-0",
        "arm": "right",
        "weightClass": "Super Heavyweight World Title – Last two rounds aren’t pulled"
      }
    ]
  },
  {
    "num": 9,
    "slug": "evw-9",
    "name": "East vs West 9",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2023-08-26",
    "matches": [
      {
        "winner": "Thomas Manghi",
        "loser": "Dustin Hyatt",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Brad Grundy",
        "loser": "Kyle Hutchison",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Derek Smith",
        "loser": "Mehdi Abvolvand",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Evgeny Prudnyk",
        "loser": "Davit Dadikyan",
        "score": "3-2",
        "arm": "left",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Adam Wawrzynski",
        "loser": "Artur Makarov",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Georgii Dzeranov",
        "loser": "Ferit Osmanli",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Ivan Matyushenko",
        "loser": "Davit Arabuli",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Vala Ichqiti",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "David Dadikyan",
        "loser": "Irakli Zirakashvili",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Paul Linn",
        "loser": "Ruslan Babaiev",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "Ibragim Sagov",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Revaz Lutidze",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Ermes Gasparini",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 8,
    "slug": "evw-8",
    "name": "East vs West 8",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2023-07-29",
    "matches": [
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Hristo Delidzhakov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Carolina Pettersson",
        "loser": "Elizabeth Rae Mocek",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Toms Rozits",
        "loser": "Justin Bishop",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Lachlan Adair",
        "loser": "Andrei Chipreanov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Rino Mašić",
        "loser": "Terence Opperman",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Oleg Petrenko",
        "loser": "Chance Shaw",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Daniel Procopciuc",
        "loser": "Emil Amirshadyan",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Sandris Sedis",
        "loser": "Pavlo Derbedyenyev",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Wagner Bortolato",
        "loser": "Ferit Osmanli",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Georgi Tsvetkov",
        "loser": "Artyom Morozov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Ermes Gasparini",
        "loser": "Jerry Cadorette",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 7,
    "slug": "evw-7",
    "name": "East vs West 7",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2023-05-06",
    "matches": [
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Oleg Cherkasov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Bacho Saginashvili",
        "loser": "Adam Wawrzynski",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Daniel Procopciuc",
        "loser": "Doug Erlich",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Zurab Tavberidze",
        "loser": "Rob Vigeant Jr.",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Alizhan Muratov",
        "loser": "Kody Merritt",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Georgii Dzeranov",
        "loser": "Arif Ertem",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Vitaly Laletin",
        "loser": "Tobias Sporrong",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Brandon Ellsessor",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Sasho Andreev",
        "loser": "Paul Linn",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Middleweight World Title"
      },
      {
        "winner": "Revaz Lutidze",
        "loser": "Dave Chaffee",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Kydyrgali Ongarbaev",
        "loser": "Irakli Zirakashvili",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight World Title"
      },
      {
        "winner": "Genadi Kvikvinia",
        "loser": "Devon Larratt",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      }
    ]
  },
  {
    "num": 6,
    "slug": "evw-6",
    "name": "East vs West 6",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2023-01-21",
    "matches": [
      {
        "winner": "Doug Erlich",
        "loser": "Raimonds Liepiņš",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Ahmet Yenerer",
        "loser": "Robert Baxter",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Efe Kömek",
        "loser": "Aitbek Beket",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Corey West",
        "loser": "Ferit Osmanli",
        "score": "3-2",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Davit Arabuli",
        "loser": "Chance Shaw",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Nurdaulet Aidarkhan",
        "loser": "Mindaugas Tarasaitis",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight World Title"
      },
      {
        "winner": "Zurab Tavberidze",
        "loser": "Curtis Cameron",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight (Curtis withdraws due to injury)"
      },
      {
        "winner": "Barbora Bajciova",
        "loser": "Gabriela Vasconcelos",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Openweight World Title"
      },
      {
        "winner": "Irakli Zirakashvili",
        "loser": "John Brzenk",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Craig Tullier",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Alizhan Muratov",
        "loser": "Oleg Petrenko",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Light Heavyweight World Title"
      },
      {
        "winner": "Arif Ertem",
        "loser": "Corey West",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Genadi Kvikvinia",
        "loser": "Ferit Osmanli",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Paul Linn",
        "loser": "Rustam Babaiev",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Middleweight World Title (Rustam withdraws due to injury)"
      },
      {
        "winner": "Jerry Cadorette",
        "loser": "Georgi Tsvetkov",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight World Title"
      }
    ]
  },
  {
    "num": 5,
    "slug": "evw-5",
    "name": "East vs West 5",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2022-11-19",
    "matches": [
      {
        "winner": "Zurab Tavberidze",
        "loser": "Ryan Bowen",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Georgii Dzeranov",
        "loser": "Serhii Kalinichenko",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Mindaugas Tarasaitis",
        "loser": "Justin Bishop",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Adam Wawrzynski",
        "loser": "Bozhidar Simeonov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Oleg Petrenko",
        "loser": "Zurab Tavberidze",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Daniel Procopciuc",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "Georgii Dzeranov",
        "loser": "Wagner Bortolato",
        "score": "3-2",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Paul Linn",
        "loser": "lrakli Gamtenadze",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "John Brzenk",
        "loser": "Oleg Petrenko",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Revaz Lutidze",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Ermes Gasparini",
        "loser": "Dave Chaffee",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Haydar Gildil",
        "loser": "Cobra Rhodes",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Sandris Sedis",
        "loser": "Matt Mask",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Ermes Gasparini",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight World Title"
      },
      {
        "winner": "Devon Larratt",
        "loser": "Evgeny Prudnik",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight World Title"
      }
    ]
  },
  {
    "num": 4,
    "slug": "evw-4",
    "name": "East vs West 4",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2022-08-06",
    "matches": [
      {
        "winner": "Raimonds Liepiņš",
        "loser": "Ryan Bowen",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Revaz Lutidze",
        "loser": "Derek Smith",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Daniel Procopciuc",
        "loser": "Corey Miller",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Chance Shaw",
        "loser": "Zurab Tavberidze",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Sandris Sedis",
        "loser": "Lachlan Adair",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Yerdaulet Sarybay",
        "loser": "Yusuf Yıldızoğlu",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Irakli Zirakashvili",
        "loser": "Krasimir Kostadinov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Dave Chaffee",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Gabriela Vasconcelos",
        "loser": "Egle Vaitkute",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Open Weight World Title"
      },
      {
        "winner": "Davit Samushia",
        "loser": "Bozhidar Simeonov",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Welterweight World Title"
      },
      {
        "winner": "David Dadikyan",
        "loser": "Oleg Zhokh",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Light Heavyweight World Title"
      },
      {
        "winner": "Gabriela Vasconcelos",
        "loser": "Egle Vaitkute",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Open Weight World Title"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Kody Merritt",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Evgeny Prudnik",
        "loser": "Todd Hutchings",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Jerry Cadorette",
        "loser": "Genadi Kvikvinia",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight World Title"
      },
      {
        "winner": "Kydyrgali Ongarbaev",
        "loser": "John Brzenk",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Light Heavyweight World Title"
      }
    ]
  },
  {
    "num": 3,
    "slug": "evw-3",
    "name": "East vs West 3",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2022-05-21",
    "matches": [
      {
        "winner": "Artyom Morozov",
        "loser": "Derek Smith",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Marcio Barboza",
        "loser": "Sahip Çağlar",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Tobias Sporrong",
        "loser": "Evgeny Prudnik",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Matt Mask",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Zurab Tavberidze",
        "loser": "Efe Kömek",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Paul Linn",
        "loser": "Davit Samushia",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Arif Ertem",
        "loser": "Krasimir Kostadinov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Marcio Barboza",
        "loser": "Tobias Sporrong",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Evgeny Prudnik",
        "loser": "Matt Mask",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "İrakli Zirakashvili",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Genadi Kvikvinia",
        "loser": "Dave Chaffee",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "John Brzenk",
        "loser": "Zurab Tavberidze",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      }
    ]
  },
  {
    "num": 2,
    "slug": "evw-2",
    "name": "East vs West 2",
    "city": "Istanbul",
    "country": "Türkiye",
    "isoDate": "2022-02-12",
    "matches": [
      {
        "winner": "Vlad Dzisiak",
        "loser": "Ramzi Tayba",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Angie Rose",
        "loser": "Anna Grönlund",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Zurab Tavberidze",
        "loser": "Jonathon Breda",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Efe Kömek",
        "loser": "Ron Bath",
        "score": "3-0",
        "arm": "left",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Sandris Šedis",
        "loser": "Chance Shaw",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Artyom Morozov",
        "loser": "Tobias Sporrong",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Fia Reisek",
        "loser": "Rebeka Martinkovicova",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Oleg Cherkasov",
        "loser": "Yusuf Yıldızoğlu",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Lightweight"
      },
      {
        "winner": "Zurab Tavberidze",
        "loser": "Ron Bath",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Aleksandr “Schoolboy” Beziazykov",
        "loser": "Herman Stevens",
        "score": "3-1",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Evgeny Prudnik",
        "loser": "Artyom Morozov",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Todd Hutchings",
        "loser": "Yordan Tsonev",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      },
      {
        "winner": "Oleg Zhokh",
        "loser": "Betkili Oniani",
        "score": "3-1",
        "arm": "left",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Ermes Gasparini",
        "loser": "Arif Ertem",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "John Brzenk",
        "loser": "Khadzimurat Zoloev",
        "score": "3-0",
        "arm": "right",
        "weightClass": "Light Heavyweight"
      }
    ]
  },
  {
    "num": 1,
    "slug": "evw-1",
    "name": "East vs West 1",
    "city": "Yalova",
    "country": "Türkiye",
    "isoDate": "2021-06-12",
    "matches": [
      {
        "winner": "Ermes Gasparini",
        "loser": "Matt Mask",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Heavyweight"
      },
      {
        "winner": "Artur Makarov",
        "loser": "Engin Terzi",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Efe Kömek",
        "loser": "Herman Stevens",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Sarah Bäckman",
        "loser": "İrina Drieva",
        "score": "5-0",
        "arm": "left",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Efe Kömek",
        "loser": "Herman Stevens",
        "score": "5-0",
        "arm": "left",
        "weightClass": "Super Heavyweight"
      },
      {
        "winner": "Sarah Bäckman",
        "loser": "İrina Drieva",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Khadzimurat Zoloev",
        "loser": "Todd Hutchings",
        "score": "3-2",
        "arm": "right",
        "weightClass": "Middleweight"
      },
      {
        "winner": "Bozhidar Simeonov",
        "loser": "Tony Kitowski",
        "score": "5-0",
        "arm": "right",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Bela Plieva",
        "loser": "Esra Kiraz",
        "score": "5-0",
        "arm": "right",
        "weightClass": "Featherweight"
      },
      {
        "winner": "Bozhidar Simeonov",
        "loser": "Tony Kitowski",
        "score": "5-0",
        "arm": "left",
        "weightClass": "Welterweight"
      },
      {
        "winner": "Joshua Grant",
        "loser": "Erkan Damar",
        "score": "4-1",
        "arm": "right",
        "weightClass": "Heavyweight"
      }
    ]
  }
];
